"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _templateObject;
const _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]).isRequired,
  withBorders: _propTypes.default.bool
};
const defaultProps = {
  children: null,
  withBorders: false
};
function Box(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(Container, props, children);
}
const Container = _styled.default.article(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 15px;\n  border-radius: 10px;\n  background-color:  ", ";\n\n  ", ";\n  ", "\n\n  @media screen and (max-width: 468px) {\n    padding: 10px;\n  }\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.NEUTRAL.CARD;
}, _ref3 => {
  let {
    withBorders,
    theme
  } = _ref3;
  return withBorders && "border: 1px solid ".concat(theme.colors.NEUTRAL.SELECTED);
}, _ref4 => {
  let {
    extraStyles
  } = _ref4;
  return extraStyles;
});
Box.propTypes = propTypes;
Box.defaultProps = defaultProps;
var _default = exports.default = Box;